import { render } from "./Desktop.vue?vue&type=template&id=02501476&scoped=true&ts=true"
import script from "./Desktop.vue?vue&type=script&lang=ts"
export * from "./Desktop.vue?vue&type=script&lang=ts"

import "./Desktop.vue?vue&type=style&index=0&id=02501476&lang=scss&scoped=true"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02501476"]])

export default __exports__